function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ./modules/components/g6_config.mjs
// ==================================================
// --------------------------------------------------

// => color codes for node attributes
var colorStatus = {
  "Error": "#F46649",
  "Success": "#5BD8A6",
  'notfound': '#99a4aa'
};
var colorJobType = {
  "Transformation": "#FFB900",
  "Orchestation": "#0179E3",
  "-": "#B381D9",
  'notfound': '#99a4aa'
};

// => container params
var container = document.getElementById('container');
var width = 943; //container.scrollWidth || 1200;
var height = 444; //container.scrollHeight || 500;

// => tree, nodes, edges params
var defLayout = {
  type: 'compactBox',
  dropCap: false,
  indent: 500,
  getHeight: function getHeight() {
    return 60;
  },
  getWidth: function getWidth() {
    return 60;
  },
  getVGap: function getVGap() {
    return 40;
  },
  getHGap: function getHGap() {
    return 100;
  }
};
var herLayout = _objectSpread(_objectSpread({}, defLayout), {}, {
  direction: 'LR'
});
var ancLayout = _objectSpread(_objectSpread({}, defLayout), {}, {
  direction: 'RL'
});
var herEdgeStyle = {
  stroke: '#ffffff',
  endArrow: true,
  startArrow: false
};
var ancEdgeStyle = {
  stroke: '#ffffff',
  endArrow: false,
  startArrow: true
};
var defaultConfig = {
  width: width,
  height: height,
  fitCenter: true,
  linkCenter: false,
  defaultLevel: 3,
  defaultZoom: 1,
  animate: true,
  padding: [20, 50],
  modes: {
    default: ['zoom-canvas', 'drag-canvas', 'drag-node']
  },
  defaultNode: {
    type: 'flow-rect'
  },
  defaultEdge: {
    type: 'edge',
    style: herEdgeStyle
  },
  layout: herLayout
};
var rectConfig = {
  width: 230,
  height: 100,
  lineWidth: 1,
  fontSize: 12,
  fill: '#fff',
  radius: 4,
  stroke: '#CED4D9',
  opacity: 1
};
var nodeOrigin = {
  x: -rectConfig.width / 2,
  y: -rectConfig.height / 2
};
var textConfig = {
  textAlign: 'left',
  textBaseline: 'bottom'
};
var nullData = {
  'id': 0,
  'job_technical_name': 'Information not found',
  'id_object': 'tbl_1685635239',
  'project': 'dev-intercorp-data-storage_sensitive_id',
  'dataset': 'master_party',
  'name': 'tmp_aux_cleaned_profiling',
  'source': 'Matillion ETL',
  'zone_name': '-',
  'company_code': '-',
  'status': 'notfound',
  'job_type': 'notfound'
};

// => exports
export { colorStatus, colorJobType, container, width, height, herLayout, ancLayout, herEdgeStyle, ancEdgeStyle, defaultConfig, rectConfig, nodeOrigin, textConfig, nullData };